import { Card, CardBody, CardFooter, CardHeader } from '@chakra-ui/react';
export const CUICard = Card;
export const CUICardBody = CardBody;
export const CUICardFooter = CardFooter;
export const CUICardHeader = CardHeader;